import { render, staticRenderFns } from "./Quotation-Invoice.vue?vue&type=template&id=4bcaab52"
import script from "./Quotation-Invoice.vue?vue&type=script&lang=js"
export * from "./Quotation-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports